import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-verify-close',
  templateUrl: './verify-close.component.html',
  styleUrls: ['./verify-close.component.css']
})
export class VerifyCloseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
